import { useTranslation } from 'react-i18next';

import type { OfferCoverageCard } from '../../../graphql/generated/graphql';

import {
    SavingsCardDetailsField,
    SavingsCardDetailsGrid,
    SavingsCardDetailsLabel,
    SavingsCardDetailsValue,
} from './SavingsCardDetails';

export type SavingsCardDataProps = {
    coverageCard: OfferCoverageCard;
};

export const SavingsCardData = ({ coverageCard }: SavingsCardDataProps) => {
    const { t } = useTranslation('lilly');

    return (
        <SavingsCardDetailsGrid>
            <SavingsCardDetailsField>
                <SavingsCardDetailsLabel>
                    {t('savingsCard.data.bin')}
                </SavingsCardDetailsLabel>
                <SavingsCardDetailsValue>
                    {coverageCard.bin}
                </SavingsCardDetailsValue>
            </SavingsCardDetailsField>
            <SavingsCardDetailsField>
                <SavingsCardDetailsLabel>
                    {t('savingsCard.data.pcn')}
                </SavingsCardDetailsLabel>
                <SavingsCardDetailsValue>
                    {coverageCard.pcn}
                </SavingsCardDetailsValue>
            </SavingsCardDetailsField>
            <SavingsCardDetailsField>
                <SavingsCardDetailsLabel>
                    {t('savingsCard.data.group')}
                </SavingsCardDetailsLabel>
                <SavingsCardDetailsValue>
                    {coverageCard.groupId}
                </SavingsCardDetailsValue>
            </SavingsCardDetailsField>
        </SavingsCardDetailsGrid>
    );
};
